import React from "react";

const SummaryTab = ({ data }) => {
  const { commonInfo, summaryInfo } = data;
  return (
    <div className="detail-bold-text">
      <div className="row detail-row">
        <div className="col-4">Harga Taksiran Akhir</div>
        <div className="col-md-auto">:</div>
        <div className="col">{summaryInfo?.finalEstimatedPrice}</div>
      </div>
      <div className="row detail-row">
        <div className="col-4">Jangka Waktu Pinjaman</div>
        <div className="col-md-auto">:</div>
        <div className="col">{summaryInfo?.tenor}</div>
      </div>
      <div className="row detail-row">
        <div className="col-4">Nilai Pinjaman</div>
        <div className="col-md-auto">:</div>
        <div className="col">{summaryInfo?.loanAmount}</div>
      </div>
      <div className="row detail-row">
        <div className="col-4">Biaya Sewa Modal</div>
        <div className="col-md-auto">:</div>
        <div className="col">{summaryInfo?.capitalLoan}</div>
      </div>
      <div className="row detail-row">
        <div className="col-4">Biaya Administrasi</div>
        <div className="col-md-auto">:</div>
        <div className="col">{summaryInfo?.feeAdmin}</div>
      </div>
      <div className="row detail-row">
        <div className="col-4">Biaya Transfer</div>
        <div className="col-md-auto">:</div>
        <div className="col">{summaryInfo?.feeTransfer}</div>
      </div>
      <div className="row detail-row">
        <div className="col-4">Biaya Simpan & Asuransi</div>
        <div className="col-md-auto">:</div>
        <div className="col">{summaryInfo?.feeSavingInsurance}</div>
      </div>
      <div className="row detail-row">
        <div className="col-4">Jumlah Diterima</div>
        <div className="col-md-auto">:</div>
        <div className="col">{summaryInfo?.takenAmount}</div>
      </div>
      <div className="row detail-row">
        <div className="col-4">Sisa Tagihan</div>
        <div className="col-md-auto">:</div>
        <div className="col">{summaryInfo?.remainderLoanAmount}</div>
      </div>
      <div className="row detail-row">
        <div className="col-4">Tanggal Jatuh Tempo</div>
        <div className="col-md-auto">:</div>
        <div className="col">{commonInfo?.dueDate}</div>
      </div>
      <div className="row detail-row">
        <div className="col-4">Foto Surat Bukti Gadai</div>
        <div className="col-md-auto">:</div>
        <div className="col">{summaryInfo?.sbgPicture}</div>
      </div>
      <div className="row detail-row">
        <div className="col-4">Offer yang Digunakan</div>
        <div className="col-md-auto">:</div>
        <div className="col">{summaryInfo?.offerName}</div>
      </div>
    </div>
  );
};

export default SummaryTab;
